<template>
    <div class="sales-order-list">
        <PageHeader title="销售订单" hidden-breadcrumb />
        <Card :bordered="false" dis-hover class="ivu-mt">
            <TableFormNew ref="tableFormNewRef" :formList="formList" @onSubmit="onSubmit" @onReset="onReset">
                <Button
                    class="ivu-ml-8"
                    slot="extraBtn"
                    type="error"
                    :loading="loadings.export"
                    :disabled="loadings.export"
                    @click="openExportModal"
                >
                    导出
                </Button>
            </TableFormNew>
        </Card>
        <Card :bordered="false" dis-hover class="ivu-mt">
            <div class="dataAnalysis-section">
                <Icon type="md-analytics" color="#3b91f7" size="24px" />
                <div class="text" style="margin-left: 6px">
                    数据统计： 参与门店 {{ orderListDataAnalysis.storeNum }}、 已支付轮胎总数
                    {{ orderListDataAnalysis.hasPayTyreNum }}、 总销售额
                    {{ orderListDataAnalysis.totalOrderAmount }}元、 总支付金额
                    {{ orderListDataAnalysis.totalOnlineOrderAmount }}元、 返利抵用
                    {{ orderListDataAnalysis.deductionAmount }}元、 线上支付
                    {{ orderListDataAnalysis.thirdPayAmount }}元、 授信支付{{ orderListDataAnalysis.creditAmount }}元
                </div>
            </div>
        </Card>
        <Card :bordered="false" dis-hover class="ivu-mt">
            <Tabs :value="currentTab" :animated="true" @on-click="handleTabClick" style="margin-top: -12px">
                <TabPane v-for="tab in tabList" :key="tab.name" :label="tab.label" :name="tab.name">
                    <FlexCustomTable
                        :list="tableConfig"
                        @onPageChange="onPageChange"
                        @onPageSizeChange="onPageSizeChange"
                        @onRefundBtnClick="onRefundBtnClick"
                        @onOffOrderBtnClick="onOffOrderBtnClick"
                        @onReturnBtnClick="handleReturnBtnClick"
                    />
                </TabPane>
            </Tabs>
        </Card>
        <RefundModal :modal.sync="isShowRefundModal" :item="item" @confirmOk="confirmOk" />
        <ReTurnModal :modal.sync="reTurnModal" :item="item" @onfirmOk="reTurnOk" />
        <OffOrderModal :modal.sync="isShowOffOrderModal" :item="item" @confirmOk="offOrderConfirmOk" />
        <Modal v-model="isShowExportModal" title="导出报表" @on-ok="exportModalOnOk">
            <div class="modal-wrapper">
                <div class="radio-label">导出维度：</div>
                <RadioGroup v-model="exportDimension" vertical>
                    <Radio label="1">
                        <span>以订单维度导出（报表中每个订单号一行）</span>
                    </Radio>
                    <Radio label="2">
                        <span>以商品维度导出（报表中每个商品名称一行）</span>
                    </Radio>
                </RadioGroup>
            </div>
        </Modal>
    </div>
</template>

<script>
import TableFormNew from '@/components/tableFormNew';
import FlexCustomTable from './customTable/flex-custom-table';
import RefundModal from './components/refundModal';
import ReTurnModal from '@/pages/sales/order/components/reTurnModal';
import OffOrderModal from '@/pages/sales/order/components/offOrderModal';
import { orderList, orderListExport, orderListDataAnalysis } from '@/api/sales';
import { clearInvalidKey } from '@/libs/util.tool.js';
import { getLabelByValue, unitDict } from '@/dicts';
import { salesOrderFormList, salesOrderColumns } from './const';

export default {
    components: { TableFormNew, FlexCustomTable, RefundModal, ReTurnModal, OffOrderModal },
    data() {
        return {
            tabList: [
                { label: '全部', name: '0' },
                { label: '待付款', name: '1' },
            ],
            currentTab: '0', // 当前tab 0全部 1待付款
            exportDimension: '1', // 导出维度
            isShowExportModal: false, // 导出弹框-显隐
            isShowRefundModal: false, // 退款弹窗-显隐
            isShowOffOrderModal: false, // 取消订单弹窗-显隐
            reTurnModal: false, // 标记发货弹窗-显隐
            item: {}, // 选择退款的列表行数据
            formList: salesOrderFormList,
            tableConfig: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                columns: salesOrderColumns,
                data: [],
                loading: false,
            },
            orderListDataAnalysis: {},
            loadings: { export: false },
        };
    },
    mounted() {
        this.getData();
        this.$bus.$on('getData', () => {
            this.getData();
        });
        this.$bus.$on('recentlyActivityIsZero', () => {
            this.formList = this.formList.filter((item) => item.prop !== 'activeIds');
        });
    },
    methods: {
        // 确认退款刷新页面
        confirmOk() {
            this.getData();
        },
        // 确认取消订单刷新页面
        offOrderConfirmOk() {
            this.getData();
        },
        // 标记发货
        reTurnOk() {
            this.getData();
        },
        // 退款
        onRefundBtnClick(item) {
            this.isShowRefundModal = true;
            this.item = item;
        },
        // 取消订单
        onOffOrderBtnClick(item) {
            this.isShowOffOrderModal = true;
            this.item = item;
        },
        // 标记发货
        handleReturnBtnClick(item) {
            this.reTurnModal = true;
            this.item = item;
        },
        //    切换tab
        handleTabClick(e) {
            if (e === this.currentTab) {
                return false;
            }
            this.currentTab = e;
            this.onPageChange(1);
        },
        // 获取筛选条件
        getScreenParams() {
            const _formData = this.$refs.tableFormNewRef.getFormData() || {};
            const { current, size } = this.tableConfig;
            return {
                ...clearInvalidKey({ ..._formData, activeIds: _formData?.activeIds?.join(',') }),
                status: this.currentTab == 1 ? 0 : null, // 状态: 0=待付款 、1=已付款、2=已完成、3=已关闭、9=已下单
                current,
                size,
            };
        },
        // 获取列表数据
        async getData() {
            this.tableConfig.loading = true;
            const params = this.getScreenParams();
            try {
                await this.getOrderListDataAnalysis(params);
                const res = await orderList(params);
                this.tableConfig.data = [];
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = (res.records || []).map((item) => {
                    item.itemsvo = item.itemsvo.map((k) => {
                        return {
                            ...k,
                            labels: k.label ? k.label.split(';') : [],
                            unitStr: getLabelByValue(unitDict, k.unit),
                        };
                    });
                    return item;
                });
            } finally {
                this.tableConfig.loading = false;
            }
        },
        // 订单数据统计
        async getOrderListDataAnalysis(params) {
            const data = await orderListDataAnalysis(params);
            this.orderListDataAnalysis = data;
        },
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
        // 查询
        onSubmit() {
            this.tableConfig.current = 1;
            this.getData();
        },
        // 重置
        onReset() {
            this.tableConfig.current = 1;
            this.tableConfig.size = window.$pageSize;
            this.getData();
        },
        // 打开导出弹框
        openExportModal() {
            this.isShowExportModal = true;
        },
        // 导出弹框-点击确定
        async exportModalOnOk() {
            let params = {
                ...clearInvalidKey(this.getScreenParams()),
                exportDimension: this.exportDimension,
            };
            try {
                this.loadings.export = true;
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await orderListExport(params);
                this.loadings.export = false;
                this.$Message.destroy();
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('export');
                    },
                });
            } catch (error) {
                this.loadings.export = false;
                this.$Message.destroy();
            }
        },
    },
};
</script>

<style lang="less">
.sales-order-list {
    .dataAnalysis-section {
        display: flex;
        align-items: center;
    }
    .order-item-column {
        margin: 0 auto;
    }
    .store-info {
        margin: 3px auto;
        font-size: 13px;
        text-align: left;
    }
}
</style>
